import { ActivityEdit } from './ActivityEdit';

export class UpdateActivityEdit extends ActivityEdit {
    public attachmentsToDelete: number[] = [];

    public constructor(init?: Partial<UpdateActivityEdit>) {
        super(init);
        Object.assign(this, init);
    }
}